import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import firebase from "../../firebase/firebase-config";
import SingleUser from '../SingleUser/SingleUser';
import SingleReportUserCard from './SingleReportUserCard';

function ReportedUsers() {
    // const [all_users, setall_users] = useState([])
    // // const [user, loading] = useAuthState(auth);
    const [All_unsolvedCases, setAll_unsolvedCases] = useState([])
    const [solvedCases, setAllsolvedCases] = useState([])
    // const [all_Approvedverifications, setall_Approvedverifications] = useState([])
    const [query, setquery] = useState('')
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const get_All_unsolvedCases = async () => {
        await firebase.firestore()
            .collection("reports")
            .where("caseStatus", "==", "unSolved").onSnapshot((reports) => {
                const unSolvedReports = [];
                reports.forEach(element => {
                    unSolvedReports.push(element.data());
                });
                setAll_unsolvedCases(unSolvedReports);
            });


    }
    const AllsolvedCases = async () => {
        await firebase.firestore()
            .collection("reports")
            .where("caseStatus", "==", "Solved").onSnapshot((reports) => {
                const unSolvedReports = [];
                reports.forEach(element => {
                    unSolvedReports.push(element.data());
                });
                setAllsolvedCases(unSolvedReports);
            });
    }


    useEffect(() => {
        get_All_unsolvedCases();
        AllsolvedCases();
    }, []);

    const search = (data) => {
        return data.filter((order_search) => order_search.orderId.toLowerCase().includes(query) || order_search.isCompleted.toLowerCase().includes(query) || order_search.products.toLowerCase().includes(query) || order_search.contact.toLowerCase().includes(query)

        );
    }
    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="12">

                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any Order..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}</span>

                                </div>

                            </div>

                        </div>


                    </Col>
                </Row>
                <Row className="d-flex justify-content-center  mt-4 align-items-center">
                    <button
                        className={toggleState === 1 ? "tabs active-tabs btn btn-primary btn-sm" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(1)}
                    >
                        Unsolved Cases({All_unsolvedCases.length})
                    </button>
                    <button
                        className={toggleState === 2 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(2)}
                    >
                        Solved Cases ({solvedCases.length})
                    </button>

                </Row>

                <div className='mt-4'>
                    <div className="content-tabs">
                        <div className={toggleState === 1 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">


                                {All_unsolvedCases.filter(user => user.uniqueId.toLowerCase().includes(query)).map((userData, i) => (


                                    <SingleReportUserCard data={userData} key={i} />

                                ))}
                            </div>



                        </div>
                        <div className={toggleState === 2 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {solvedCases.filter(user => user.uniqueId.toLowerCase().includes(query)).map((userData, i) => (


                                    <SingleReportUserCard data={userData} key={i} />

                                ))}
                            </div>
                        </div>


                    </div>

                </div>


            </div>

        </>
    )
}

export default ReportedUsers;